import * as React from 'react';
import styled from 'styled-components';
import media from './fpp_media_queries';
import TextComponent from './text_component';
import { ProductReviews } from '@ifixit/product-page-components';

const HeadingContainer = styled.div`
   padding-bottom: 40px;
   ${media.mobileLandscapeAll} {
      padding-bottom: 20px;
   }
`;

const reviewsProps = {
   reviewsLink: window.cart_constants.GuideURI('USER_REVIEWS_LINK'),
};

const FppReviewsComponent = ({ heading, ...props }) => (
   <React.Fragment>
      <HeadingContainer>
         <TextComponent subheading={_js('Customer Reviews')} />
      </HeadingContainer>
      <ProductReviews {...reviewsProps} {...props} />
   </React.Fragment>
);

export default FppReviewsComponent;
